<template>
  <div class="checkTable">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      <div class="headTxt">查询爬取丹灶数据</div>
    </div>
    <el-form ref="dataForm" class="searchForm" :model="dataForm">
      <el-form-item>
        <el-date-picker
          v-model="dataForm.startDate"
          type="date"
          class="fullList"
          placeholder="请选择开始时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        />
        <el-date-picker
          v-model="dataForm.endDate"
          type="date"
          class="fullList"
          placeholder="请选择结束时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        />
        <el-button type="primary" class="fullList" @click="getDataList(1)">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      lazy
      v-loading="dataListLoading"
      height="calc(100vh - 50px - 260px)"
      style="width: 100%"
    >
      <el-table-column
        prop="dateTime"
        header-align="center"
        align="center"
        width="100"
        fixed="left"
        label="时间"
      >
        <template slot-scope="scope">
          {{ scope.row.dateTime.substr(0, 16) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="insFlow"
        header-align="center"
        align="center"
        label="进水瞬时流量"
      />
      <el-table-column
        prop="dzInsFlow"
        header-align="center"
        align="center"
        label="丹灶瞬时流量"
      />
      <el-table-column
        prop="ccInsFlow"
        header-align="center"
        align="center"
        label="禅城瞬时流量"
      />
      <el-table-column
        prop="xjInsFlow"
        header-align="center"
        align="center"
        label="西樵瞬时流量"
      />
      <el-table-column
        prop="ssInsFlow"
        header-align="center"
        align="center"
        label="狮山瞬时流量"
      />
      <el-table-column
        prop="cumFlow"
        header-align="center"
        align="center"
        width="170"
        label="进水累计流量"
      />
      <el-table-column
        prop="dzCumFlow"
        header-align="center"
        align="center"
        width="170"
        label="丹灶累计流量"
      />
      <el-table-column
        prop="ccCumFlow"
        header-align="center"
        align="center"
        width="170"
        label="禅城累计流量"
      />
      <el-table-column
        prop="xjCumFlow"
        header-align="center"
        align="center"
        width="170"
        label="西樵累计流量"
      />
      <el-table-column
        prop="ssCumFlow"
        header-align="center"
        align="center"
        width="170"
        label="狮山累计流量"
      />
    </el-table>
    <el-pagination
        background
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :pager-count="pageCount"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        style="margin: 15px 0;text-align: center"
        layout="prev, pager, next"
    />
  </div>
</template>

<script>
import moment from "moment"
export default {
  data () {
    return {
      popstateLock: 0, //是否监听物理返回键
      dataForm: {
        startDate: moment(new Date()).startOf("month").format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD")
      },
      pageCount: 5,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      stationOptions: [],
      dataList: [], // 数据列表
      dataListLoading: false, // 数据加载
      loading: true
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate();
      }else{
        this.removePopstate();
      }
    }
  },
  mounted () {
    this.getDataList()
    this.addPopstate(); //在导航栏挂载的时候，对物理返回键进行监听
  },
  destroyed(){
    this.removePopstate();
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 获取选中的地址信息
    getStation(val) {
      this.stationOptions.forEach(item => {
        if (item.id === val) {
          this.dataForm.area = item.flowMeterName
        }
      })
    },
    // 后面获取数据列表
    async getDataList(type) {
      this.dataListLoading = true;
      if (this.dataForm.startDate === null || this.dataForm.startDate === '') {
        this.dataForm.startDate = moment(new Date()).startOf("month").format("YYYY-MM-DD")
      }
      if (this.dataForm.endDate === null || this.dataForm.endDate === '') {
        this.dataForm.endDate = moment(new Date()).format("YYYY-MM-DD")
      }
      if (type === 1) {
        this.pageIndex = 1;
      }
      if (moment(this.dataForm.endDate).isBefore(this.dataForm.startDate) === false) {
        // 根据获取的数据请求符合条件的工单
        await this.$http.httpGet('/app/stateData/dzList', {
          startDateTime: this.dataForm.startDate + " 00:00:00",
          endDateTime: this.dataForm.endDate + " 23:59:59",
          page: this.pageIndex,
          limit: this.pageSize
        }).then(res => {
          this.loading = false
          if (res.code === 0 && res.msg === 'success') {
            this.dataList = res.page.list;
            this.totalPage = res.page.totalCount;
            this.dataListLoading = false;
          } else {
            this.$message.error('获取数据失败: ' + res.msg);
            this.totalPage = 0;
            this.dataList = [];
            this.dataListLoading = false;
          }
        }).catch(() => {
          this.dataListLoading = false;
        })
      } else {
        this.$message.error("结束时间必须大于开始时间");
        this.dataListLoading = false;
      }
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 返回首页
    backIndex() {
      this.$router.push({ name: 'Index' });
    }
  },

}
</script>

<style lang="scss">
.checkTable {
  position: relative;
  padding: 60px 10px 0;
  .headLine {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 600;
    background-color: #409eff;
    color: #fff;
    text-align: center;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .headTxt {
      font-size: 16px;
      line-height: 50px;
    }
  }
  .searchForm {
    position: relative;
    .el-form-item {
      margin: 0 0 10px;
      position: relative;
      overflow: hidden;
      .el-form-item__content {
        .fullList {
          width: 100% !important;
          margin: 0 0 10px;
        }
        .el-select {
          width: 75%;
          float: left;
        }
        .el-button {
          width: 22%;
          float: right;
        }
      }
    }
  }
}
</style>
